var Site = {};

function headerFixed() {
  var headerContainer = $('.header-content-wrapper'),
    logoWhite = headerContainer.find('[data-logo-white]').data('logo-white'),
    logoBlack = headerContainer.find('[data-logo-black]').data('logo-black'),
    e = $('.header--sticky');

  if (100 < $(document).scrollTop()) {
    e.addClass('header--fixed');
    $('.header-content-wrapper img').attr('src', logoBlack);
  } else {
    e.removeClass('header--fixed');
    $('.header-content-wrapper img').attr('src', logoWhite);
  }
}

function loadMap(country) {
  if (country == 'US') {
    // Center map in America if user is there
    var lat = 39.069443,
      long = -94.974968;
  } else {
    if ($(window).width() > 767) {
      // On mobile, move map to the right so we see bit of England
      var lat = 48.8719,
        long = 12.5674;
    } else {
      // View on desktop
      var lat = 50.373765,
        long = 3.510744;
    }
  }

  var e = $(window),
    t = $(document),
    s = $('#site-header'),
    a = $('.site-countdown-number'),
    i = $('#primary-menu'),
    n = $('#hellopreloader');

  Site.maps = {
    maps: {
      employers: {
        config: {
          id: 'map-employer',
          map: {
            dragging: $(window).width() < 1024 ? false : true,
            tap: $(window).width() < 1024 ? false : true,
            center: new L.LatLng(lat, long),
            zoom: 5,
            maxZoom: 18,
            layers: new L.tileLayer(
              'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
              {
                maxZoom: 18,
                attribution:
                  '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
              }
            ),
          },
          icon: {
            iconSize: [24, 30],
            iconAnchor: [15, 34],
            popupAnchor: [-3, -7],
            className: '',
          },
          cluster: { iconSize: [40, 49] },
          dragging: $(window).width() < 1024 ? false : true,
          tap: $(window).width() < 1024 ? false : true,
        },
        markers: Site.mapMarkers(),
      },
    },
    init: function () {
      var n = this;
      for (var o in this.maps) {
        var s = this.maps[o];
        if (s.config && s.markers && document.getElementById(s.config.id)) {
          var e = new L.map(s.config.id, s.config.map),
            r = L.markerClusterGroup({
              iconCreateFunction: function (e) {
                var t = e.getChildCount(),
                  a = s.config.cluster;
                return new L.DivIcon({
                  html: '<div><span>' + t + '</span></div>',
                  className: 'marker-cluster marker-cluster-' + o,
                  iconSize: new L.Point(a.iconSize[0], a.iconSize[1]),
                });
              },
            });
          s.markers.forEach(function (e) {
            s.config.icon.iconUrl =
              '/wp-content/themes/invenia/assets/graphics/' + e.icon;
            var t = L.icon(s.config.icon),
              a = L.marker(e.coords, { icon: t }),
              i = a.bindPopup(e.popup);
            r.addLayer(a), 'candidates' === o && n.toggleMarkerClass(i);
          }),
            e.addLayer(r),
            this.disableScroll(jQuery('#' + s.config.id), e);
        }
      }
    },
    toggleMarkerClass: function (e) {
      e.on('popupopen', function (e) {
        jQuery(e.popup._source._icon).addClass('active-marker');
      }),
        e.on('popupclose', function (e) {
          jQuery(e.popup._source._icon).removeClass('active-marker');
        });
    },
    disableScroll: function (e, t) {
      t.scrollWheelZoom.disable(),
        e.bind('mousewheel DOMMouseScroll', function (e) {
          e.stopPropagation(),
            1 == e.ctrlKey
              ? (e.preventDefault(),
                t.scrollWheelZoom.enable(),
                setTimeout(function () {
                  t.scrollWheelZoom.disable();
                }, 1e3))
              : t.scrollWheelZoom.disable();
        });
    },
  };

  Site.maps.init();
}

!(function ($) {
  'use strict';
  InitWaypointAnimations({
    animateClass: 'js-animate',
  });

  var e = $(window),
    t = $(document),
    s = $('#site-header'),
    a = $('.site-countdown-number'),
    i = $('#primary-menu'),
    n = $('#hellopreloader');
  (Site.countdowns = function () {
    a.each(function () {
      $(this).TimeCircles({
        circle_bg_color: 'transparent',
        animation_interval: 'ticks',
        number_size: 0.36,
        text_size: 0.12,
        time: {
          Days: { color: 'transparent' },
          Hours: { color: 'transparent' },
          Minutes: { color: 'transparent' },
          Seconds: { color: 'transparent' },
        },
      });
    });
  }),
    $('.site-accordion button').on('click', function () {
      var e = $(this).closest('.card').find('.collapse').hasClass('show');
      $(this)
        .closest('.site-accordion')
        .find('.card-header')
        .removeClass('active'),
        e
          ? $(this).parents('.card-header').removeClass('active')
          : $(this).parents('.card-header').toggleClass('active');
    }),
    (Site.select2Init = function () {
      $('.puzzle--select').select2();
    }),
    (Site.primaryMenu = function () {
      i.crumegamenu({
        showSpeed: 200,
        hideSpeed: 200,
        trigger: 'hover',
        animation: 'none',
        effect: 'fade',
        indicatorFirstLevel: '',
        indicatorSecondLevel: '',
      });
    }),
    (Site.fixedHeader = function () {
      headerFixed();

      $(document).on('scroll', function () {
        headerFixed();
      });
    }),
    (Site.mapMarkers = function () {
      return window.jobs;
    }),
    (Site.initSmoothScroll = function () {
      if ('querySelector' in document && 'addEventListener' in window) {
        for (
          var e = $('#primary-menu a[href*=\\#], .btn[href*=\\#]').filter(
              function () {
                return $(this).is(':not([href=\\#])');
              }
            ),
            t = 0,
            a = e.length;
          t < a;
          t++
        ) {
          new RegExp(window.location.hostname + window.location.pathname).test(
            e[t].href
          ) && e[t].setAttribute('data-scroll', !0);
        }
        if (window.location.hash) {
          var i = document.querySelector(window.location.hash),
            n = document.querySelector(
              'a[href*="' + window.location.hash + '"]'
            );
          smoothScroll.animateScroll(i, n, {});
        }
        smoothScroll.init({
          selector: '[data-scroll]',
          speed: 500,
          easing: 'easeOutQuad',
          offset: s.height(),
          updateURL: !0,
          callback: function (e, t) {},
        }),
          $('#primary-menu')
            .find('[href=\\#]')
            .on('click', function () {
              return !1;
            });
      }
    }),
    (Site.initTextareaEditor = function () {
      var e = $('#froala-editor');
      e.length && e.froalaEditor();
    }),
    (Site.Swiper = {
      $swipers: {},
      init: function () {
        var i = this;
        $('.swiper-container').each(function (e) {
          var t = $(this),
            a = 'swiper-unique-id-' + e;
          t.addClass(a + ' initialized').attr('id', a),
            t
              .closest('.site-module')
              .find('.swiper-pagination')
              .addClass('pagination-' + a),
            (i.$swipers[a] = new Swiper('#' + a, i.getParams(t, a))),
            i.addEventListeners(i.$swipers[a]);
        });
      },
      getParams: function (e, t) {
        var a = {
          autoHeight: e.data('auto-height') ? true : 0,
          parallax: !0,
          keyboardControl: !0,
          setWrapperSize: !0,
          preloadImages: !0,
          updateOnImagesReady: !0,
          prevNext: !!e.data('prev-next') && e.data('prev-next'),
          changeHandler: e.data('change-handler')
            ? e.data('change-handler')
            : '',
          direction: e.data('direction') ? e.data('direction') : 'horizontal',
          mousewheelControl: !!e.data('mouse-scroll') && e.data('mouse-scroll'),
          mousewheelReleaseOnEdges:
            !!e.data('mouse-scroll') && e.data('mouse-scroll'),
          slidesPerView: e.data('show-items') ? e.data('show-items') : 1,
          mobileSlides: e.data('mobile-slides')
            ? e.data('mobile-slides')
            : false,
          slidesPerGroup: e.data('scroll-items') ? e.data('scroll-items') : 1,
          spaceBetween:
            e.data('space-between') || 0 == e.data('space-between')
              ? e.data('space-between')
              : 20,
          centeredSlides:
            !!e.data('centered-slider') && e.data('centered-slider'),
          autoplay: e.data('autoplay')
            ? {
                delay: e.data('autoplay-speed')
                  ? e.data('autoplay-speed')
                  : 5000,
              }
            : 0,
          loop: e.data('loop') == false ? 0 : 1,
          effect: e.data('effect') ? e.data('effect') : 'slide',
          pagination: {
            type: e.data('pagination') ? e.data('pagination') : 'bullets',
            el: '.pagination-' + t,
            clickable: !0,
          },
          coverflow: {
            stretch: e.data('stretch') ? e.data('stretch') : 0,
            depth: e.data('depth') ? e.data('depth') : 0,
            slideShadows: !1,
            rotate: 0,
            modifier: 2,
          },
          fade: { crossFade: !e.data('crossfade') || e.data('crossfade') },
        };

        if (a.mobileSlides) {
          return (
            1 < a.slidesPerView &&
              (a.breakpoints = {
                300: { slidesPerView: a.mobileSlides, slidesPerGroup: 1 },
                767: {
                  slidesPerView: a.slidesPerView,
                  slidesPerGroup: a.slidesPerGroup,
                },
              }),
            a
          );
        } else {
          return (
            1 < a.slidesPerView &&
              (a.breakpoints = {
                1: { slidesPerView: 1, slidesPerGroup: 1 },
                800: { slidesPerView: a.slidesPerView, slidesPerGroup: 2 },
              }),
            a
          );
        }
      },
      addEventListeners: function (t) {
        var e = t.$el.closest('.site-module-slider');
        t.params.prevNext &&
          e.on('click', '.swiper-btn-next, .swiper-btn-prev', function (e) {
            e.preventDefault(),
              $(this).hasClass('swiper-btn-next')
                ? t.slideNext()
                : t.slidePrev();
          });
      },
    }),
    jQuery('.back-to-top').on('click', function () {
      return $('html,body').animate({ scrollTop: 0 }, 1200), !1;
    }),
    (Site.mediaPopups = function () {
      $('.js-popup-iframe').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: !1,
        fixedContentPos: !1,
      }),
        $('.js-zoom-image, .link-image').magnificPopup({
          type: 'image',
          removalDelay: 500,
          callbacks: {
            beforeOpen: function () {
              (this.st.image.markup = this.st.image.markup.replace(
                'mfp-figure',
                'mfp-figure mfp-with-anim'
              )),
                (this.st.mainClass = 'mfp-zoom-in');
            },
          },
          closeOnContentClick: !0,
          midClick: !0,
        });
    }),
    (Site.pricingSwitcher = function () {
      jQuery('.js-pricing-switcher').on('click', function () {
        var e = $(this).prev().is(':checked');
        $(this)
          .closest('.site-pricings')
          .find('.price')
          .each(function () {
            e
              ? $(this).text($(this).data('annually'))
              : $(this).text($(this).data('monthly'));
          });
      });
    }),
    (Site.IsotopeSort = function () {
      $('.sorting-container').each(function () {
        var t = $(this),
          e = t.data('layout').length ? t.data('layout') : 'masonry';
        t.isotope({
          itemSelector: '.sorting-item',
          layoutMode: e,
          percentPosition: !0,
        }),
          t.imagesLoaded().progress(function () {
            t.isotope('layout');
          }),
          t
            .closest('.sorting-section-js')
            .find('.sorting-menu')
            .find('li')
            .on('click', function () {
              if ($(this).hasClass('active')) return !1;
              $(this).parent().find('.active').removeClass('active'),
                $(this).addClass('active');
              var e = $(this).data('filter');
              return void 0 !== e ? (t.isotope({ filter: e }), !1) : void 0;
            });
      });
    }),
    (Site.burgerAnimation = function () {
      var a = 80,
        i = 320,
        t = 80,
        n = 320;
      function e(e) {
        e.draw('80% - 240', '80%', 0.3, {
          delay: 0.1,
          callback: function () {
            e.draw('100% - 545', '100% - 305', 0.6, {
              easing: ease.ease('elastic-out', 1, 0.3),
            });
          },
        });
      }
      function $(e) {
        e.draw(t - 60, n + 60, 0.1, {
          callback: function () {
            e.draw(t + 120, n - 120, 0.3, {
              easing: ease.ease('bounce-out', 1, 0.3),
            });
          },
        });
      }
      function s(t) {
        t.draw('90% - 240', '90%', 0.1, {
          easing: ease.ease('elastic-in', 1, 0.3),
          callback: function () {
            var e;
            (e = t).draw('20% - 240', '20%', 0.3, {
              callback: function () {
                e.draw(a, i, 0.7, { easing: ease.ease('elastic-out', 1, 0.3) });
              },
            });
          },
        });
      }
      var r = document.getElementById('pathD'),
        c = document.getElementById('pathE'),
        l = document.getElementById('pathF'),
        u = new Segment(r, a, i),
        p = new Segment(c, t, n),
        d = new Segment(l, a, i),
        h = document.getElementById('menu-icon-wrapper'),
        g = document.getElementById('menu-icon-trigger'),
        m = !0;
      (h.style.visibility = 'visible'),
        (g.onclick = function () {
          (h.className = 'menu-icon-wrapper scaled'),
            m
              ? (e(u), $(p), e(d))
              : (s(u),
                p.draw(t, n, 0.7, {
                  delay: 0.1,
                  easing: ease.ease('elastic-out', 2, 0.4),
                }),
                s(d)),
            (m = !m),
            setTimeout(function () {
              h.className = 'menu-icon-wrapper';
            }, 450);
        });
    }),
    (Site.tabsSmothScroll = {
      $tabs: null,
      init: function () {
        (this.$tabs = jQuery('.tabs-scroll')), this.addEventListeners();
      },
      addEventListeners: function () {
        this.$tabs.on('shown.bs.tab', function (e) {
          var t = jQuery(e.target),
            a = jQuery(t.prop('hash'));
          100 < window.scrollY ||
            (a.length && smoothScroll.animateScroll(a[0]));
        });
      },
    }),
    (Site.StickySidebars = function () {
      var e = $('#site-header').height();
      $('.site-sticky-sidebar').each(function () {
        new StickySidebar(this, {
          topSpacing: e,
          bottomSpacing: 20,
          containerSelector: !1,
          innerWrapperSelector: '.sidebar__inner',
          stickyClass: 'is-affixed',
          minWidth: 0,
        });
      });
    }),
    t.ready(function () {
      Site.select2Init(),
        Site.fixedHeader(),
        Site.Swiper.init(),
        Site.initSmoothScroll(),
        Site.mediaPopups(),
        Site.countdowns(),
        Site.pricingSwitcher(),
        Site.IsotopeSort(),
        //Site.headerSpacer.init(),
        Site.tabsSmothScroll.init(),
        Site.primaryMenu(),
        Site.StickySidebars(),
        // Site.maps.init(),
        Site.initTextareaEditor(),
        //Site.updateResponsiveInit(),
        $('#primary-menu').length && Site.burgerAnimation();
    });

  $('.swiper-container').hover(
    function () {
      this.swiper.autoplay.stop();
    },
    function () {
      this.swiper.autoplay.start();
    }
  );

  $.get(
    'https://pro.ip-api.com/json?key=WK4FE1gOFBXZME6',
    function (response) {
      var country = response.countryCode;

      loadMap(country);
    },
    'json'
  );
})(jQuery);
